import React from "react";

import Upload from "components/Upload";
import Header from "components/Header";
import {
  Typography,
  Link,
  Grid,
  Box,
  StyledEngineProvider,
} from "@mui/material";
import HowItWorks from "components/HowItWorks";
// import PrivacySection from "components/PrivacySection";
import FAQSection from "components/FAQSection";
import Container from "uikit/Container";
import Footer from "components/Footer";

import * as styles from "../styles/Home.css";
import Image from "next/image";
import Requirements from "components/Requirements";
import * as commonStyles from "styles/common.css";

export default function Home() {
  return (
    <div>
      <StyledEngineProvider injectFirst>
        <div style={{ paddingTop: 70 }}>
          <Header logoShown />
          <Container background="primary" className={styles.home}>
            <Box className={styles.surfer1ImgWrapper}>
              <Box className={styles.img}>
                <Image
                  src="/surfer.png"
                  priority
                  alt="surfer"
                  layout="fill"
                  sizes="(max-width: 768px) 40vw, 20vw"
                />
              </Box>
            </Box>
            <Grid
              container
              sx={{ margin: "1rem auto", width: "70%" }}
              alignItems="center"
              direction="column"
              gap={4}
            >
              <h1 className={styles.heading}>
                Analyze Your Bank Statements Instantly with Stat Analyzer
              </h1>
              <h2 className={styles.subtitle}>
                Transform PDF Bank Statements into Interactive Financial
                Insights.
                <p>Export your data to CSV.</p>
              </h2>
              <h3 className={styles.subtitle}>
                Get 100 free PDF uploads with your{" "}
                <a href="/api/auth/login">free account</a>
              </h3>
              <Upload />
              <Typography fontSize="1.5rem">
                Try Our{" "}
                <Link href="/demo" className={commonStyles.link}>
                  Demo
                </Link>{" "}
                and Explore Your Financial Insights
              </Typography>
            </Grid>
          </Container>
          <Container
            background="primary"
            style={{ paddingTop: "4rem" }}
            className={styles.howItWorks}
            id="how-it-works"
          >
            <Box className={styles.surfer2ImgWrapper}>
              <Box className={styles.img}>
                <Image
                  src="/surfer1.png"
                  priority
                  alt="surfer"
                  layout="fill"
                  sizes="(max-width: 768px) 40vw, 20vw"
                />
              </Box>
            </Box>
            <HowItWorks />
          </Container>
          {/* <Container background="secondary" margin="lg">
            <PrivacySection />
          </Container> */}
          <Container id="requirements" background="primary" margin="lg">
            <Requirements />
          </Container>
          <Container background="primary" margin="lg" className={styles.faq}>
            <Box className={styles.surfer3ImgWrapper}>
              <Box className={styles.img}>
                <Image
                  src="/surfer3.png"
                  priority
                  alt="surfer"
                  layout="fill"
                  sizes="(max-width: 768px) 40vw, 20vw"
                />
              </Box>
            </Box>
            <FAQSection />
          </Container>
          <Footer />
        </div>
      </StyledEngineProvider>
    </div>
  );
}
